module.exports = __webpack_public_path__ + "static/media/check-black.6e4ade1b.svg";